import { flattenObject, isObject } from './miscUtils';

export const parseErrorMessage = error => {
  const contentType = error?.response?.headers?.['content-type'] ?? '';
  const messages = [];

  if (contentType.match('html') || !error?.response?.data) {
    if (error?.message) messages.push(error.message);
  } else {
    const { data } = error.response;

    if (data.detail) {
      messages.push(data.detail);
    } else if (data.error) {
      messages.push(data.error);
    } else {
      const errors = data?.params ? data.params : data;

      Object.keys(errors).forEach(key => {
        if (key === 'non_field_errors') {
          // error does not pertain to a specific field
          if (Array.isArray(data[key])) {
            messages.push(...data[key]);
          } else {
            messages.push(data[key]);
          }
        } else if (isObject(errors[key])) {
          const flattenedErrors = flattenObject(errors[key]);
          Object.entries(flattenedErrors).forEach(([flatKey, flatValue]) => {
            const displayKey = /^\d+$/.test(flatKey) ? key : flatKey;
            messages.push(`${displayKey}: ${flatValue}`);
          });
        } else {
          // error pertains to a specific field
          messages.push(`${key}: ${data[key]}`);
        }
      });
    }
  }

  // Fallback default message
  if (messages.length === 0) {
    messages.push('Oops. Something went wrong - ');
  }

  return messages;
};
